import { render, staticRenderFns } from "./QuickActionsGrid.vue?vue&type=template&id=3b4e202a&scoped=true&"
import script from "./QuickActionsGrid.vue?vue&type=script&lang=js&"
export * from "./QuickActionsGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4e202a",
  null
  
)

export default component.exports